import dayjs from 'dayjs';
import ReportPreviewProfileLabel from 'app/modules/analytics/modules/reports/components/reportPreview/ReportPreviewProfileLabel';
import ReportPreviewNameAndPeriod from 'app/modules/analytics/modules/reports/components/reportPreview/ReportPreviewNameAndPeriod';
import type { ReportPreviewLayout } from 'app/modules/analytics/modules/reports/constants/reportPreviewPageShellClassName';
import { formatReportPreviewDateRange } from 'app/modules/analytics/modules/reports/utils/formatReportPreviewDateRange';

interface Props {
  profileLabel: string;
  profileLogoSrc?: string;
  profilePageType?: number;
  reportName: string;
  since: string;
  until: string;
  layout?: ReportPreviewLayout;
}

const ViewReportPreviewPageHeader = ({
  profileLabel,
  profileLogoSrc,
  profilePageType,
  reportName,
  since,
  until,
  layout = 'modal',
}: Props) => {
  const rangeLabel =
    since && until
      ? formatReportPreviewDateRange(dayjs(since), dayjs(until))
      : undefined;

  return (
    <header
      className={`tw-flex tw-shrink-0 tw-break-inside-avoid tw-justify-between tw-gap-4 tw-border-b tw-border-grayscale-20 tw-pb-4 ${
        layout === 'export' ? 'tw-items-start' : 'tw-items-center'
      }`}
      data-cy="analytics_view-report_preview-page-header"
    >
      <ReportPreviewProfileLabel
        label={profileLabel}
        pageLogoSrc={profileLogoSrc}
        pageType={profilePageType}
      />
      <ReportPreviewNameAndPeriod
        reportName={reportName}
        rangeLabel={rangeLabel}
        layout={layout}
      />
    </header>
  );
};

export default ViewReportPreviewPageHeader;
